import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addArticle, articleDetail } from '../../Redux/actions/homeAction';
import { stateList } from '../../Redux/actions/userAction';
import { getToken } from '../../Helper/Session';
import { inputPlaceHolders, isEmpty } from "../../Helper/Util";
import { Loader } from '../Common/Loader';
import Header from '../Layout/Header';

class EditArticle extends Component {
    constructor(props) {
        super(props)
        this.state = {
            article_id: 0,
            article_title: '',
            state: '',
            weburl: '',
            url: '',
            article_description: '',
            image: null,
            height: 0,
            width: 0,
            errors: {}
        }
    }
    componentDidUpdate() {
        inputPlaceHolders()
    }

    handleChange = e => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value,
            errors: {
                ...this.state.errors,
                [e.target.name]: ''
            }
        })
    }

    handleImgChange = (e) => {
        var file = e.target.files[0];
        let reader = new FileReader();
        reader.onload = (e) => {
            let images = e.target.result;
            this.setState({
                image: images.split(';base64')[1],
                errors: {
                    image: ''
                }
            });
        };
        reader.readAsDataURL(file);
    };

    componentDidMount() {
        this.setState({
            article_id: this.props.match.params.id
        })
        const params = {
            apikey: process.env.REACT_APP_API_KEY,
        }
        this.props.stateList(params);
        const aParams = {
            apikey: process.env.REACT_APP_API_KEY,
            article_id: this.props.match.params.id
        }
        this.props.articleDetail(aParams);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { home: { articleDetail } } = nextProps;
        this.setState({
            article_title: articleDetail.article_title ? articleDetail.article_title : '',
            article_description: articleDetail.article_description ? articleDetail.article_description : '',
            url: articleDetail.url ? articleDetail.url : '',
            state: articleDetail.stateid ? articleDetail.stateid : '',
            weburl: articleDetail.weburl ? articleDetail.weburl : '',
        })
    }

    validate = () => {
        const { article_title, article_description, state } = this.state;
        let errors = {};
        if (isEmpty(article_title)) errors.article_title = true;
        if (isEmpty(article_description)) errors.article_description = true;
        if (isEmpty(state)) errors.state = true;
        return errors;
    }

    handleSubmit = (e) => {
        e.preventDefault()
        let token = getToken() !== null ? JSON.parse(getToken()) : '';
        const errors = this.validate();
        if (Object.keys(errors).length !== 0) {
            this.setState({ errors });
            return false;
        }
        const { home: { aCurrentPage } } = this.props;
        const params = {
            article_id: this.state.article_id,
            article_title: this.state.article_title,
            state: this.state.state,
            weburl: this.state.weburl,
            article_description: this.state.article_description,
            image: this.state.image,
            height: this.state.height,
            width: this.state.width,
            userid: token.id,
            apikey: process.env.REACT_APP_API_KEY
        }
        this.props.addArticle(params, this.props.history, token.admin, aCurrentPage);
    }

    render() {
        const { errors } = this.state;
        const { home: { states }, UI: { loading } } = this.props;
        let stateMarkup = !loading ? states !== undefined && states.length > 0 ?
            states.map((result, i) => <option value={result.id} selected={result.id === this.state.state} key={i}>{result.name}</option>) :
            <p>No Data</p> : <Loader />;
        return (
            <section className="main-Section">
                <form className="form-block formBox" onSubmit={this.handleSubmit}>
                    <Header
                        title={'Edit Article'}
                        backUrl={'articles-legislation'}
                        saveBtn={true}
                        loading={loading}
                    />
                    <div className="container-fluid midSection scrollSection">
                        <div className="content">
                            <fieldset>
                                <span className="placeholder">Title</span>
                                <input type="text" name="article_title" className={`form-control input__field ${errors.article_title ? 'inputError' : ''}`} value={this.state.article_title} onChange={this.handleChange} />
                            </fieldset>
                            <fieldset className="selectInput redAro">
                                <span className="placeholder">State</span>
                                <select className={`form-control input__field ${errors.state ? 'inputError' : ''}`} name="state" value={this.state.state} onChange={this.handleChange}>
                                    <option value=''>Select State</option>
                                    {stateMarkup}
                                </select>
                            </fieldset>
                            <fieldset>
                                <span className="placeholder">Website (optional)</span>
                                <input type="text" name="weburl" className={`form-control input__field`} value={this.state.weburl} onChange={this.handleChange} />
                            </fieldset>
                            <fieldset className="input--filled">
                                <span className="placeholder">Description</span>
                                <textarea name="article_description" className={`form-control input__field ${errors.article_description ? 'inputError' : ''}`} value={this.state.article_description} onChange={this.handleChange} ></textarea>
                            </fieldset>
                            <div className="profileBrowse">
                                <div className="profileImage">
                                    {this.state.image ? (
                                        <figure><img src={this.state.image ? (`data:image/png;base64` + this.state.image) : "./images/logo.png"} alt="Fig" /></figure>
                                    ) :
                                        <figure><img src={this.state.url !== '' ? process.env.REACT_APP_API_URL + this.state.url : '../images/logo.png'} alt="Fig" /></figure>
                                    }
                                    <label className="addProfile">
                                        <img src="../images/add.png" alt="User" />
                                        <input type="file" name="image" onChange={this.handleImgChange} />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        )
    }
}

const mapStateToProps = (state) => ({
    home: state.home,
    UI: state.UI
})

const mapActionToProps = {
    addArticle,
    articleDetail,
    stateList
}

export default connect(mapStateToProps, mapActionToProps)(EditArticle);